<div class="layout-padding" fxLayout='column'>
  <div fxLayout.gt-sm='row' fxLayout.lt-md="column" fxLayoutAlign='space-between start' fxLayoutAlign.lt-md="start stretch">
    <button mat-stroked-button type="button" [routerLink]="'/dashboard/' + dashboardId">
      <mat-icon>keyboard_arrow_left</mat-icon>
      Back to Dashboard
    </button>
  </div>
</div>
